import React from "react";
import PropTypes from "prop-types";
import BondBasicInformationBase from "./BondBasicInformationBase";
import { HISTORIC_GLOBAL_BASIC_FORM } from "../../../../pages/SHARED/Bond Creation Historic/components/historicCreationSharedPropTypes";

const HistoricBasicInformationSection = (props) => (
  <BondBasicInformationBase {...props} surface="historic" />
);

HistoricBasicInformationSection.propTypes = {
  config: PropTypes.object.isRequired,
  globalData: HISTORIC_GLOBAL_BASIC_FORM.globalData,
  data: HISTORIC_GLOBAL_BASIC_FORM.data,
  updateData: HISTORIC_GLOBAL_BASIC_FORM.updateData,
  errors: HISTORIC_GLOBAL_BASIC_FORM.errors,
};

export default HistoricBasicInformationSection;
